import React from 'react'
import Spinner from './spinner'

interface IButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'error' | 'link' | 'success'
  size?: 'small' | 'default' | 'large'
  loading?: boolean
  dashed?: boolean
  disabled?: boolean
  block?: boolean
  skeleton?: boolean
}

const Button: React.FC<IButtonProps> = ({
  children,
  variant = 'default',
  skeleton,
  loading,
  dashed,
  block,
  size,
  ...rest
}) => {
  return (
    <button
      disabled={loading}
      className={`button button-${variant} ${block ? 'block' : ''} ${
        dashed ? 'dashed' : ''
      } button-${size} ${skeleton ? 'skeleton' : ''}`}
      {...rest}
      onClick={(e) => !skeleton && rest.onClick && rest.onClick(e)}
    >
      <div className='button-content'>
        <div
          className='button-value'
          style={{
            opacity: loading ? 0 : 1
          }}
        >
          {children}
        </div>
        {loading && (
          <div className='button-spinner'>
            <Spinner size='small' />
          </div>
        )}
      </div>
    </button>
  )
}

export default Button
